import { render } from "./threshold.vue?vue&type=template&id=22f4b79d&scoped=true"
import script from "./threshold.vue?vue&type=script&lang=js"
export * from "./threshold.vue?vue&type=script&lang=js"

import "./threshold.vue?vue&type=style&index=0&id=22f4b79d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f4b79d"]])

export default __exports__